// (() => {
//   if (window.__cartRecoBound) return;
//   window.__cartRecoBound = true;

//   const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

//   const themeModules = Promise.all([
//     import('@theme/morph').catch(() => null),
//     import('@theme/events').catch(() => null),
//   ]);

//   /* ---------- helpers ---------- */
//   const getDrawer = () => document.querySelector('cart-drawer-component');

//   function getDrawerSectionId() {
//     const drawer = getDrawer();
//     const s = drawer && drawer.closest('[id^="shopify-section-"]');
//     return s ? s.id.replace('shopify-section-', '') : 'cart-drawer-section';
//   }

//   function isDrawerOpen() {
//     const drawer = getDrawer();
//     if (!drawer) return false;
//     const dialog = drawer.querySelector('dialog');
//     return !!(dialog && dialog.open) || drawer.hasAttribute('open');
//   }

//   function morphInto(live, fresh, morphModule) {
//     if (morphModule && typeof morphModule.morph === 'function') {
//       try { morphModule.morph(live, fresh); return; } catch (e) {}
//     }
//     live.innerHTML = fresh.innerHTML;
//   }

//   function applyDrawerHtml(sections, sectionId, morphModule) {
//     const html = sections && sections[sectionId];
//     if (!html) return false;

//     const doc = new DOMParser().parseFromString(html, 'text/html');
//     const freshDrawer = doc.querySelector('cart-drawer-component');
//     const liveDrawer = getDrawer();
//     if (!freshDrawer || !liveDrawer) return false;

//     morphInto(liveDrawer, freshDrawer, morphModule);

//     const freshIcon = doc.querySelector('.header-actions__cart-icon');
//     const liveIcon = document.querySelector('.header-actions__cart-icon');
//     if (freshIcon && liveIcon && !liveDrawer.contains(liveIcon)) {
//       morphInto(liveIcon, freshIcon, morphModule);
//     }
//     return true;
//   }

//   function openDrawerIfClosed() {
//     if (isDrawerOpen()) return;
//     const drawer = getDrawer();
//     if (!drawer) return;
//     if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
//     if (typeof drawer.showDialog === 'function') { try { drawer.showDialog(); return; } catch (e) {} }
//     const dialog = drawer.querySelector('dialog');
//     if (dialog && !dialog.open) { try { dialog.showModal(); } catch (e) {} }
//   }

//   /* ---------- add to cart ---------- */
//   let busy = false;

//   async function handleAdd(button) {
//     const variantId = button.dataset.variantId;
//     if (!variantId || busy) return;

//     busy = true;
//     const safety = setTimeout(() => { busy = false; }, 10000);

//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'ADDING';

//     const sectionId = getDrawerSectionId();
//     const wasOpen = isDrawerOpen();

//     try {
//       const response = await fetch(ROOT + 'cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({
//           items: [{ id: Number(variantId), quantity: 1 }],
//           sections: sectionId,
//           sections_url: window.location.pathname,
//         }),
//       });

//       const json = await response.json();
//       if (!response.ok || json.status) {
//         throw new Error(json.description || json.message || 'Unable to add product');
//       }

//       const [morphModule, eventsModule] = await themeModules;

//       let sections = json.sections || {};
//       if (!sections[sectionId]) {
//         try {
//           const r = await fetch(
//             window.location.pathname + '?sections=' + encodeURIComponent(sectionId),
//             { cache: 'no-store' }
//           );
//           sections = await r.json();
//         } catch (e) {}
//       }

//       applyDrawerHtml(sections, sectionId, morphModule);

//       try {
//         const cart = await fetch(ROOT + 'cart.js', { cache: 'no-store' }).then((r) => r.json());
//         if (eventsModule && eventsModule.CartAddEvent) {
//           document.dispatchEvent(
//             new eventsModule.CartAddEvent(cart, 'cart-recommendation', {
//               source: 'cart-recommendation',
//               itemCount: cart.item_count,
//               sections,
//             })
//           );
//         }
//       } catch (e) {}

//       if (!wasOpen) setTimeout(openDrawerIfClosed, 50);

//       if (document.contains(button)) {
//         button.textContent = 'ADDED';
//         setTimeout(() => {
//           button.textContent = originalText;
//           button.disabled = false;
//         }, 1200);
//       }
//     } catch (error) {
//       console.error('[Cart Recommendations] Add to cart error:', error);
//       if (document.contains(button)) {
//         button.textContent = 'ERROR';
//         setTimeout(() => {
//           button.textContent = originalText;
//           button.disabled = false;
//         }, 1500);
//       }
//     } finally {
//       clearTimeout(safety);
//       busy = false;
//     }
//   }

//   /* ---------- one listener for every ADD button, now and after any re-render ---------- */
//   document.addEventListener('click', (event) => {
//     const button = event.target.closest('.cart-recommendation__add');
//     if (!button) return;
//     event.preventDefault();
//     event.stopPropagation();
//     handleAdd(button);
//   }, true);
// })();

(() => {
  if (window.__cartRecoBound) return;
  window.__cartRecoBound = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const themeModules = Promise.all([
    import('@theme/morph').catch(() => null),
    import('@theme/events').catch(() => null),
  ]);

  /* ---------- helpers ---------- */
  const getDrawer = () => document.querySelector('cart-drawer-component');

  function getSectionId(el) {
    const s = el && el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  // Drawer section + the section that holds the header cart icon
  function getSectionIds() {
    const ids = [];
    const push = (id) => { if (id && !ids.includes(id)) ids.push(id); };
    push(getSectionId(getDrawer()) || 'cart-drawer-section');
    push(getSectionId(document.querySelector('cart-icon, .header-actions__cart-icon')));
    return ids;
  }

  function isDrawerOpen() {
    const drawer = getDrawer();
    if (!drawer) return false;
    const dialog = drawer.querySelector('dialog');
    return !!(dialog && dialog.open) || drawer.hasAttribute('open');
  }

  function morphInto(live, fresh, morphModule) {
    if (morphModule && typeof morphModule.morph === 'function') {
      try { morphModule.morph(live, fresh); return; } catch (e) {}
    }
    live.innerHTML = fresh.innerHTML;
  }

  function applySections(sections, morphModule) {
    Object.keys(sections || {}).forEach((id) => {
      const html = sections[id];
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Drawer
      const freshDrawer = doc.querySelector('cart-drawer-component');
      const liveDrawer = getDrawer();
      if (freshDrawer && liveDrawer) morphInto(liveDrawer, freshDrawer, morphModule);

      // Header cart icon
      const freshIcon = doc.querySelector('cart-icon') || doc.querySelector('.header-actions__cart-icon');
      const liveIcon = document.querySelector('cart-icon') || document.querySelector('.header-actions__cart-icon');
      if (freshIcon && liveIcon && !(liveDrawer && liveDrawer.contains(liveIcon))) {
        morphInto(liveIcon, freshIcon, morphModule);
      }
    });
  }

  // Fallback so the number is always right
  function setCartCount(count) {
    document
      .querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"], .cart-count-bubble span, .cart-count')
      .forEach((el) => { el.textContent = count; });

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', count === 0);
      bubble.hidden = count === 0;
    });
  }

  function openDrawerIfClosed() {
    if (isDrawerOpen()) return;
    const drawer = getDrawer();
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    if (typeof drawer.showDialog === 'function') { try { drawer.showDialog(); return; } catch (e) {} }
    const dialog = drawer.querySelector('dialog');
    if (dialog && !dialog.open) { try { dialog.showModal(); } catch (e) {} }
  }

  /* ---------- add to cart ---------- */
  let busy = false;

  async function handleAdd(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || busy) return;

    busy = true;
    const safety = setTimeout(() => { busy = false; }, 10000);

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'ADD';

    const sectionIds = getSectionIds();
    const wasOpen = isDrawerOpen();

    try {
      const response = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const json = await response.json();
      if (!response.ok || json.status) {
        throw new Error(json.description || json.message || 'Unable to add product');
      }

      const [morphModule, eventsModule] = await themeModules;

      let sections = json.sections || {};
      if (!Object.keys(sections).some((k) => sections[k])) {
        try {
          const r = await fetch(
            window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.join(',')),
            { cache: 'no-store' }
          );
          sections = await r.json();
        } catch (e) {}
      }

      applySections(sections, morphModule);

      try {
        const cart = await fetch(ROOT + 'cart.js', { cache: 'no-store' }).then((r) => r.json());
        setCartCount(cart.item_count);

        if (eventsModule && eventsModule.CartAddEvent) {
          document.dispatchEvent(
            new eventsModule.CartAddEvent(cart, 'cart-recommendation', {
              source: 'cart-recommendation',
              itemCount: cart.item_count,
              sections,
            })
          );
        }
      } catch (e) {}

      if (!wasOpen) setTimeout(openDrawerIfClosed, 50);

      if (document.contains(button)) {
        button.textContent = 'ADD';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1200);
      }
    } catch (error) {
      console.error('[Cart Recommendations] Add to cart error:', error);
      if (document.contains(button)) {
        button.textContent = 'ERROR';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      }
    } finally {
      clearTimeout(safety);
      busy = false;
    }
  }

  /* ---------- one listener for every ADD button, now and after any re-render ---------- */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cart-recommendation__add');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    handleAdd(button);
  }, true);
})();